import { CardioOrResistance, GymTypes } from 'fitbeat.models';
import { WorkoutPausesConfig } from '../../config/workoutpausesconfig';
import { SessionSequenceEntry } from './sessionsequenceentry';

export class SessionSequence {
    public static changeZonesVideo(): string {
        return '0TEMP_NEXT_ZONEWAIT_DANCE_MOVE_REPLACEMENT';
    }

    public static preWarmupVideoName(): string {
        return '0PRE_WARMUP';
    }

    public static preWarmdownVideoName(): string {
        return '0PRE_WARMDOWN';
    }

    public static postWarmdownVideoName(): string {
        return '0END_OF_WORKOUT';
    }

    public static getAllVideos(): string[] {
        return [
            this.changeZonesVideo(),
            this.preWarmupVideoName(),
            this.preWarmdownVideoName(),
            this.postWarmdownVideoName(),
            WorkoutPausesConfig.pauseVideoFileNameWithoutExtentionCardio,
            WorkoutPausesConfig.pauseVideoFileNameWithoutExtentionResistance,
            WorkoutPausesConfig.pauseVideoFileNameWithoutExtentionBalance,
        ];
    }

    public static getPauseVideoFileName(
      cardioOrResistance: CardioOrResistance,
      gymType: GymTypes,
      isBoxing = false,
    ): string {
        if (isBoxing) {
          return WorkoutPausesConfig.pauseVideoFileNameWithoutExtentionBoxing;
        }

        if (gymType === GymTypes.Home) {
            if (cardioOrResistance === CardioOrResistance.Resistance) {
                return WorkoutPausesConfig.pauseVideoFileNameWithoutExtentionResistanceHome;
            }
            if (cardioOrResistance === CardioOrResistance.Balance) {
                return WorkoutPausesConfig.pauseVideoFileNameWithoutExtentionBalanceHome;
            }
            return WorkoutPausesConfig.pauseVideoFileNameWithoutExtentionCardioHome;
        }

        if (cardioOrResistance === CardioOrResistance.Resistance) {
            return WorkoutPausesConfig.pauseVideoFileNameWithoutExtentionResistance;
        } else if (cardioOrResistance === CardioOrResistance.Cardio) {
            return WorkoutPausesConfig.pauseVideoFileNameWithoutExtentionCardio;
        } else {
            return WorkoutPausesConfig.pauseVideoFileNameWithoutExtentionBalance;
        }
    }

    public durationInMilliseconds: number;
    public sequence: SessionSequenceEntry[];
}
